/**
 * Toggles amounts for donations / extra funds for subscriptions.
 */

import { Controller } from "stimulus"
import { csrfFetch } from "utils/fetch";

export default class extends Controller {
  connect() {
    this.intentId = this.element.dataset["intentId"];

    this.element.querySelectorAll(".amount-button").forEach(el => {
      el.addEventListener('click', this.setFixedAmount.bind(this));
    });

    this.element.querySelector('.other-button').addEventListener('click', this.toggleOther.bind(this));
    this.element.querySelector('.other-input input').addEventListener('change', this.setOtherAmount.bind(this));
  
    this.updateAmount(this.element.querySelector(".button.positive").dataset["amount"]);
  }

  disconnect() {
    this.element.querySelectorAll(".amount-button").forEach(el => {
      el.removeEventListener('click', this.setFixedAmount.bind(this));
    });
  }

  toggleOther(event) {
    this.setSelected(event.currentTarget);
  }

  setOtherAmount(event) {
    const amount = +(event.currentTarget.value);
    if (!isNaN(amount)) {
      this.updateAmount(amount * 100);
    } else {
      event.currentTarget.classList.remove("positive");
      event.currentTarget.classList.add("negative");
    }
  }

  setFixedAmount(event) {
    this.setSelected(event.target);
    this.updateAmount(event.target.dataset["amount"]);
  }

  async updateAmount(amount) {
    const response = await csrfFetch(`/donations/update_amount?intent_id=${this.intentId}&amount_cents=${amount}`, {
      method: 'PUT'
    });
    if (response.status !== 200) {
      alert("We ran into a problem updating your donation amount. Please try again later.");
    }

    // Update the payment request client side so the right amount displays
    if (window.stripePayment) {
      window.stripePayment.paymentRequest.update({
        total: {
          label: "Total",
          amount: parseInt(amount)
        }
      });
    }
  }

  setSelected(button) {
    const current = this.element.querySelector(".button.positive");
    if (current) {
      current.classList.remove("positive");
      current.classList.add("neutral");
    }
    button.classList.remove("neutral");
    button.classList.add("positive");
    if (button.classList.contains("other-button")) {
      button.querySelector('.other-input').classList.remove('hidden');
      button.querySelector('.other-text').classList.add('hidden');
      button.querySelector('.other-input input').focus();
    } else {
      this.element.querySelector('.other-button .other-input').classList.add('hidden');
      this.element.querySelector('.other-button .other-text').classList.remove('hidden');
    }
  }
}